import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";

const ROUTES = [
  {
    match: /^\/$/,
    title: "Handmade Ceramic Mugs, Planters & Decor | Riaas Collective",
    description:
      "Shop handmade ceramic mugs, glasses, salt & pepper sets, planters and decorative pots online — food-safe glazes, delivered across India.",
  },
  {
    match: /^\/shop/,
    title: "Shop All Handmade Ceramics | Riaas Collective",
    description:
      "Browse the full collection of handmade ceramic mugs, glasses, planters, salt & pepper sets and decor items from Riaas Collective.",
  },
  {
    match: /^\/terms/,
    title: "Terms & Conditions | Riaas Collective",
    description:
      "The terms that govern shopping at Riaas Collective — orders, payment, pricing, shipping and use of this website.",
  },
  {
    match: /^\/returns/,
    title: "Returns & Exchange Policy | Riaas Collective",
    description:
      "How returns, exchanges and refunds work at Riaas Collective — a 7-day window for damaged or incorrect ceramic orders.",
  },
  {
    match: /^\/wholesale/,
    title: "Wholesale & Bulk Ceramic Orders | Riaas Collective",
    description:
      "Bulk and B2B enquiries for cafés, boutiques, hotels and gifting programmes — volume pricing on handmade ceramics from Riaas Collective.",
  },
  { match: /^\/checkout/, title: "Checkout | Riaas Collective", noindex: true },
  { match: /^\/order\//, title: "Order Confirmed | Riaas Collective", noindex: true },
  { match: /^\/admin/, title: "Admin | Riaas Collective", noindex: true },
];

const Seo = () => {
  const { pathname } = useLocation();
  const route = ROUTES.find((r) => r.match.test(pathname));
  if (!route) return null;
  return (
    <Helmet>
      <title>{route.title}</title>
      {route.description && <meta name="description" content={route.description} />}
      <meta property="og:title" content={route.title} />
      {route.description && <meta property="og:description" content={route.description} />}
      <meta name="twitter:title" content={route.title} />
      {route.description && <meta name="twitter:description" content={route.description} />}
      {route.noindex && <meta name="robots" content="noindex, nofollow" />}
    </Helmet>
  );
};

export default Seo;
